module.exports = "/_next/static/images/uv-text-2-e49a47c376c6d7b4fec1c6c44a719c5c.png";